import { FEATHER_MAP } from './featherIcons';

/**
 * Render the icon for a block "move-to" destination button (18px to match
 * delete/confirm). Shared by BlockEditorPanel's move-to chip row.
 *
 * dest: { type: 'nodes' | 'node', path?, label, icon? }
 */
export function renderDestIcon(dest) {
  if (dest.type === 'nodes') {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      </svg>
    );
  }
  // QA node — use its custom icon (feather SVG or emoji)
  if (dest.icon) {
    if (dest.icon.startsWith('feather:')) {
      const name = dest.icon.slice(8);
      const IconComponent = FEATHER_MAP[name];
      if (IconComponent) {
        return <IconComponent size={18} strokeWidth={2} />;
      }
      // Fallback file icon if feather name not found
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>
      );
    }
    return <span style={{ fontSize: '18px', lineHeight: 1 }}>{dest.icon}</span>;
  }
  // Fallback: file icon
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  );
}
